module.exports = __webpack_public_path__ + "static/media/logo_icon.be4dc6ce.jpg";